module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-129052278-1","head":true,"anonymize":false,"respectDNT":false,"pageTransitionDelay":0,"optimizeId":"GTM-K8NRKK3","experimentId":"ul6z9oVfQ_2YJmihj8rmnw","variationId":0,"sampleRate":100,"siteSpeedSampleRate":10},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/kin-icon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"2o5vtCWRdqhvixLAPadjTt0gvzihxiRX","devKey":"gtOxA8UAIlc3qbfv11EwloRWvrTT3lST","trackPage":true,"delayLoad":false,"delayLoadTime":1000},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"464874957653645"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
